import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/scenes/name', 'put'>;
type ResponseBody = OASOutput<O, '/api/scenes/name', 'put'>;

type Params = {
  sceneId: number;
  newName: string;
};

type Result = {
  id: number;
};

export const renameSceneFactory = (apiClient: ApiClient) => {
  const renameScene = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/scenes/name'].put(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        sceneId: input.sceneId,
        newName: input.newName,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      id: response.id,
    };
  };

  return renameScene;
};
